import { create } from "zustand"
import { persist } from "zustand/middleware"

// Note: This store is mainly using for storing information that only using on the client.
// The data will be kept on current session only, and will be removed when the user close the tab.
interface State {
  data: Record<string, any>
}

interface Actions {
  setData: (key: string, value: any) => void
  getData: (key: string) => any
  removeData: (key: string) => void
  clearData: () => void
}

type Store = State & Actions

const useSessionCache = create<Store, [["zustand/persist", Store]]>(
  persist(
    (set, get) => ({
      data: {},
      getData: (key: string) => {
        return get().data?.[key] ?? null
      },
      setData: (key: string, value: any) => {
        set((state) => {
          state.data[key] = value
          return state
        })
      },
      removeData: (key: string) => {
        set((state) => {
          if (state.data) {
            delete state.data[key]
          }
          return state
        })
      },
      clearData: () => {
        set({ data: {} })
      },
    }),
    {
      name: "be:cache",
      version: 1,
    }
  )
)

export { useSessionCache }
